const ADMIN_USERS_ENDPOINTS = {
  login: '/admin_users/sign_in',
  loginGoogle: '/admin_users/google_sign_in',
  logout: '/admin_users/sign_out',
  signUp: '/admin_users'
};

const NOTIFICATIONS_ENDPOINTS = {
  notifications: '/notifications',
  getNotification: id => `/notifications/${id}`,
  markNotification: '/notifications/mark_user_notifications_seen',
  acknowledgeNotification: id => `/notifications/${id}/mark_notification_acknowledged`
};

const ASSIGNMENTS_ENDPOINTS = {
  assignments: (start, end) => `/assignments?start_date=${start}&end_date=${end}`,
  updateAssignment: (start, end, id) => `/assignments/${id}?start_date=${start}&end_date=${end}`,
  getAssignment: id => `/assignments/${id}`,
  getAssignmentNote: id => `/assignments/notes/${id}`
};

const PEOPLE_ENDPOINTS = {
  people: '/people',
  getPeopleExperience: (id, highlighted) => `/people/${id}/experiences?highlighted=${highlighted}`,
  getPeopleSoftSkills: id => `/people/${id}/soft_skills`,
  getPeopleDetails: id => `/people/${id}/personal_page`,
  getPerson: id => `/people/${id}`,
  gerPersonTechnicalSkill: id => `/people/${id}/technical_skills`,
  getPersonSpecialEvents: id => `/people/${id}/special_events`,
  updatePersonSpecialEvents: (personId, specialEventId) =>
    `/people/${personId}/special_events/${specialEventId}`,
  getPeopleByAssignment: id => `/search_people/assignments/${id}`
};

const PROJECTS_ENDPOINTS = {
  projects: '/projects',
  minimalProjects: '/projects/minimal',
  getProject: id => `/projects/${id}`,
  projectStatuses: '/project_statuses',
  getProjectStatus: id => `/project_statuses/${id}`,
  getProjectsOverviewTotals: '/project_overview/projects/totals/',
  getProjectsOverview: '/project_overview/projects',
  getProjectOverviewDetail: id => `/project_overview/projects/${id}`,
  getFinishedAssignments: id => `project_details/finished_assignments?project_id=${id}`,
  getProjectAssignments: id => `/project_timeline/projects/${id}/project_assignments`
};

const FINANCIAL_ENDPOINTS = {
  financialProjects: '/financial/projects',
  getFinancialProject: id => `/financial/projects/${id}`,
  getFinancialResourceSetup: id => `/financial/projects/${id}/periods/setups`,
  getProjectClosedPeriods: id => `/financial/projects/${id}/periods/closed`,
  getProjectOpenedPeriods: id => `/financial/projects/${id}/periods/opened`,
  getProjectOpenedResources: id => `/financial/projects/${id}/periods/resources`,
  financialPeriod: '/financial/periods',
  getFinancialPeriod: id => `/financial/periods/${id}`,
  closeOpenPeriod: id => `/financial/periods/${id}/close`,
  financialSetups: `/financial/setups`,
  refreshFinancialResourceSetup: id => `/financial/projects/${id}/setups/refresh`,
  getRefreshedFinancialResourceSetup: id => `/financial/projects/${id}/setups/refreshed`,
  getExportData: (startDate, endDate) =>
    `/financial/exports?start_date=${startDate}&end_date=${endDate}`
};

const FORECASTING_ENDPOINTS = {
  getProjectsTotals: '/forecasting/project_totals',
  getProjectsForecasting: '/forecasting/projects',
  getForecastingGraph: '/forecasting/graph'
};

const RESOURCE_PROFILES_ENDPOINTS = {
  getDisciples: '/resource_profiles/disciples',
  getResourceProfile: id => `/resource_profiles/profiles/${id}`,
  getResourceProfileTimeOffs: id => `/resource_profiles/profiles/${id}/time_offs`,
  getResourceProfileProjects: id => `/resource_profiles/profiles/${id}/assignments`,
  getResourceProfileBio: id => `/integrations/bios?person_id=${id}`,
  getResourceProfileTimeline: (id, startDate, endDate) =>
    `/resource_profiles/profiles/${id}/timeline?start_date=${startDate}&end_date=${endDate}`
};

const DASHBOARD_ENDPOINTS = {
  dashboardPeopleTable: '/allocations_dashboard/people',
  dashboardPeopleAvailabilitiesTable: '/allocations_dashboard/people/availabilities',
  dashboardBenchBreakdownTable: '/bench_breakdown/people',
  dashboardBenchBreakdownSkills: '/bench_breakdown/skills',
  dashboardUtilization: '/dashboard/utilizations',
  dashboardUtilizationQuarters: '/dashboard/utilizations/quarter_blocks',
  dashboardUtilizationCorner: '/dashboard/utilizations/corner',
  dashboardSkills: '/dashboard/skills',
  dashboardUtilizationBench: '/dashboard/utilizations/bench_overview',
  dashboardFinancialOverviews: '/dashboard/financial/overviews',
  dashboardFinancialProjectTypesMargin: '/dashboard/financial/project_types_margins',
  dashboardFinancialRevenues: '/dashboard/financial/revenues',
  dashboardFinancialQuarters: '/dashboard/financial/quarter_blocks',
  dashboardBenchOverview: '/dashboard/bench/overviews',
  dashboardBenchCorner: '/dashboard/bench/corner',
  dashboardBenchQuarters: '/dashboard/bench/quarter_blocks',
  dashboardBenchList: (startDate, endDate) =>
    `/dashboard/bench/list?start_date=${startDate}&end_date=${endDate}`
};

const SETTINGS_ENDPOINTS = {
  settingsResources: '/settings/access_roles',
  settingsEditRole: id => `/settings/access_roles/${id}`,
  settingsGroups: '/groups',
  roleGroups: '/settings/role_groups',
  editRoleRelation: id => `/settings/role_groups/${id}`
};

export const ENDPOINTS = {
  availabilities: '/resource_timeline/resources',
  skills: allSkills => `/skills?all_skills=${allSkills}`,
  clients: '/clients',
  departments: '/departments',
  locations: '/locations',
  roles: '/roles',
  industries: '/industries',
  dashboardPeople: '/dashboard_people',
  assignmentSummary: '/assignment_summaries',
  ...DASHBOARD_ENDPOINTS,
  ...ADMIN_USERS_ENDPOINTS,
  ...ASSIGNMENTS_ENDPOINTS,
  ...NOTIFICATIONS_ENDPOINTS,
  ...PEOPLE_ENDPOINTS,
  ...PROJECTS_ENDPOINTS,
  ...FINANCIAL_ENDPOINTS,
  ...FORECASTING_ENDPOINTS,
  ...RESOURCE_PROFILES_ENDPOINTS,
  ...SETTINGS_ENDPOINTS
};
